// extracted by mini-css-extract-plugin
export default {"footerWrapper":"VAb8s","footer":"GV0Ed","lightPage":"ndvQU","hidden":"gQf8n","toggleButton":"BnlQI","link":"QKBbk","fadeInUp":"OvWpc"};